import * as React from 'react';
import { useEffect } from 'react';

import { api } from '@api/reduxApi';
import { TagList } from '@components/tags';
import { Tooltip } from '@components/Tooltip';

import { useBulkUploadActions } from '../../../context';

import { CellFC } from './types';

export const Tags: CellFC = ({ row, tabIndex }) => {
  const [updateRepoSession, { isSuccess, data }] = api.useUpdateRepoSessionMutation();
  const [updateInsight, { isSuccess: isUpdatingInsightSuccess, data: insight }] = api.useUpdateInsightMutation();
  const { setItem } = useBulkUploadActions();

  useEffect(() => {
    if (isSuccess) {
      setItem({ ...(row.original as RecordingItem | ZoomItem), session: data });
    }
  }, [isSuccess]);

  useEffect(() => {
    if (isUpdatingInsightSuccess) {
      setItem({ ...(row.original as RepoFileItem), insight });
    }
  }, [isUpdatingInsightSuccess]);

  const handleChange = (tagIds: number[]) => {
    if (row.original.type === 'repoFile' && row.original.insight?.id) {
      updateInsight({ ...row.original.insight, tag_ids: tagIds });
    } else {
      updateRepoSession({
        uuid: (row.original as RecordingItem | ZoomItem).session.uuid,
        tag_ids: tagIds
      });
    }
    setItem({ ...row.original, tagIds });
  };

  return (
    <Tooltip
      content='Tags can be changed when the upload is complete.'
      isDisabled={row.original.status === 'done' || row.original.type !== 'repoFile'}
    >
      <TagList
        readOnly={row.original.status !== 'done' && row.original.type === 'repoFile'}
        tagIds={row.original.tagIds}
        previewShowLimit={2}
        onChange={handleChange}
        wrapperClassName='w-64'
        dropdownClassName='z-50'
        placement='bottom'
        className='flex h-10 items-center space-x-2 px-4'
        tabIndex={tabIndex}
        hideManagerLinks
      />
    </Tooltip>
  );
};
